import { SIP_STATUS_TO_CALL_STATE } from 'Modules/softphone/constants';
import type { CallState, SipStatusCategory } from 'Modules/softphone/types';

/**
 * Maps SIP status code to CallState
 *
 * Useful for handling rejection/error callbacks from SIP.js
 */
export function mapSipStatusCode(statusCode: number): CallState | null {
  return SIP_STATUS_TO_CALL_STATE[statusCode] ?? null;
}

/**
 * Gets the SIP status category from a status code
 *
 * @param statusCode - The SIP status code
 * @returns The status category
 */
export function getSipStatusCategory(statusCode: number): SipStatusCategory {
  if (statusCode >= 100 && statusCode < 200) return 'provisional';
  if (statusCode >= 200 && statusCode < 300) return 'success';
  if (statusCode >= 300 && statusCode < 400) return 'redirection';
  if (statusCode >= 400 && statusCode < 500) return 'clientError';
  if (statusCode >= 500 && statusCode < 600) return 'serverError';
  return 'globalError';
}
